import { Badge, IconElement } from '@wix/design-system';
import { useTranslation } from '@wix/wix-i18n-config';
import React, { FunctionComponent, useState } from 'react';

import { DATA_HOOKS } from '../../../../../../dataHooks';

import css from './index.module.scss';

export type SearchBadgeType = {
  key: string;
  icon: IconElement;
};

export type SearchBadgeProps = {
  badge: SearchBadgeType;
  onClick: () => void;
};

export const SearchBadge: FunctionComponent<SearchBadgeProps> = ({
  badge,
  onClick,
}) => {
  const { t } = useTranslation();
  const [isHovered, setIsHovered] = useState(false);

  return (
    <div
      className={css.searchBarModalBadge}
      key={badge.key}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={onClick}
      data-hook={DATA_HOOKS.SEARCH_BAR_MODAL_BADGE}
      tabIndex={0}
    >
      <Badge
        skin={isHovered ? 'general' : 'neutralLight'}
        prefixIcon={badge.icon}
      >
        {t(badge.key)}
      </Badge>
    </div>
  );
};
